import { Component, OnInit } from "@angular/core";
import { iM } from "@angular/core/src/render3";

@Component({
  selector: "app-health-check-note-number",
  templateUrl: "./health-check-note-number.component.html",
  styleUrls: ["./health-check-note-number.component.css"],
})
export class HealthCheckNoteNumberComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
